import { EMAIL, INSTAGRAM_URL, SITE_URL } from "@/constants/links";

export default function Footer() {
    return (
        <footer data-testid="footer-container" className="border-t border-cream/10">
            <div className="mx-auto w-full max-w-[1240px] px-6 py-14 md:px-10">
                <div className="grid gap-10 md:grid-cols-2">
                    <div>
                        <img
                            src="/logo.png"
                            alt="Bi Kadraj Media"
                            className="h-9 w-auto md:h-10"
                        />
                        <p className="mt-4 max-w-xs text-sm leading-relaxed text-fog">
                            İşletmeler için sosyal medya içerik ve prodüksiyon
                            ekibi.
                        </p>
                    </div>

                    <div className="flex flex-col gap-3 md:items-end md:justify-start">
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-instagram"
                            className="text-sm text-cream/80 transition-colors hover:text-cream"
                        >
                            @bikadraj.media
                        </a>
                        <a
                            href={`mailto:${EMAIL}`}
                            data-testid="footer-email"
                            className="text-sm text-cream/80 transition-colors hover:text-cream"
                        >
                            info@bikadraj.com
                        </a>
                        <a
                            href={SITE_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-site"
                            className="text-sm text-cream/80 transition-colors hover:text-cream"
                        >
                            bikadraj.com
                        </a>
                    </div>
                </div>

                <div className="mt-12 flex flex-col gap-2 border-t border-cream/10 pt-6 text-xs text-dim sm:flex-row sm:items-center sm:justify-between">
                    <span>© {new Date().getFullYear()} Bi Kadraj Media</span>
                    <span>bikadraj.com</span>
                </div>
            </div>
        </footer>
    );
}
